export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/mika-matin-c9f1c0957a16a2d70a6dd210949aa18c.jpg";